import type { PlacedOrderResponse } from 'apiConnector/secondary-market/cp-order/model';
import { fromSecondaryMarket } from 'state/selectors';
import type { Thunk } from 'state/state.common';
import {
  workspaceTabFrozen,
  workspaceTabRemoved,
  workspaceTabSetBusy,
  workspaceTabUnactivated,
  workspaceTabUnfrozen,
} from 'state/workspaces/workspace.actions';

import {
  secondaryMarketCpOrderPlacementClose,
  secondaryMarketCpOrderPlacementFailed,
  secondaryMarketCpOrderPlacementReceived,
  secondaryMarketCpOrderPlacementRequested,
} from './order.actions';

export function secondaryMarketCpOrderPlacementRequestedThunk(tabId: string): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    const request = fromSecondaryMarket.cpOrder.getPlaceOrderRequest(state, tabId);

    dispatch(secondaryMarketCpOrderPlacementRequested(tabId, request));
    dispatch(workspaceTabFrozen(tabId, 'secondaryMarketQuotes', true));
  };
}

export function secondaryMarketCpOrderPlacementFailedThunk(
  tabId: string,
  isTimeout: boolean,
  errorMessage?: string,
  timeout?: number,
): Thunk<void> {
  return dispatch => {
    dispatch(secondaryMarketCpOrderPlacementFailed(tabId, isTimeout, errorMessage, timeout));
    dispatch(workspaceTabSetBusy(tabId, 'secondaryMarketQuotes', false));
  };
}

export function secondaryMarketCpOrderPlacementReceivedThunk(tabId: string, data: PlacedOrderResponse): Thunk<void> {
  return dispatch => {
    dispatch(secondaryMarketCpOrderPlacementReceived(tabId, data));
    dispatch(workspaceTabSetBusy(tabId, 'secondaryMarketQuotes', false));
  };
}

export function secondaryMarketCpOrderPlacementCloseThunk(tabId: string, closeTab = false): Thunk<void> {
  return (dispatch, _) => {
    dispatch(secondaryMarketCpOrderPlacementClose(tabId));
    dispatch(workspaceTabUnfrozen(tabId, 'secondaryMarketQuotes', false));
    if (closeTab === true) {
      dispatch(workspaceTabRemoved(tabId, 'secondaryMarketQuotes'));
      dispatch(workspaceTabUnactivated('secondaryMarketQuotes'));
    }
  };
}
